module.exports = __webpack_public_path__ + "static/media/reportsIcon.64f0dda2.svg";